import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./blogDetail.css";
import { StoreContext } from "../../../store/Provider";
import MainLayout from "../../common/Layout/MainLayout";

function BlogsDetail() {
  // const history = useHistory();
  const navigate = useNavigate();
  const context = useContext(StoreContext);

  return (
    // <MainLayout>
    <div className="blogDetailComponent">
      {/* <div className="blogDetailHeader">
                <h6>
                     <span onClick={history.goBack} className="pointer">Go Back</span> 
                    <span onClick={history.goBack} className="pointer">
                        <img src="/Assets/Images/backArrow.svg" alt="backArrow" /></span>
                </h6>
            </div> */}
      <div className="blogDetailBody">
        <div className="blogDetailBodyInner">
          <div className="container">
            
            <div className="blogDetails">
              <h5>{context.blogsDetail.title}</h5>
              <img
              className="blogDetailBanner mt-5 mb-5"
              alt="blog Banner"
              src={context.blogsDetail.image}
            />
              <div
                dangerouslySetInnerHTML={{ __html: context.blogsDetail.detail }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    // </MainLayout>
  );
}

export default BlogsDetail;
